"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthTxStatus = exports.TxTypeToEthFunctionName = exports.EthTxType = void 0;
/**
 * @hidden
 */
var EthTxType;
(function (EthTxType) {
    EthTxType["REVEAL_LOCATION"] = "REVEAL";
    EthTxType["INIT"] = "INIT";
    EthTxType["MOVE"] = "MOVE";
    EthTxType["UPGRADE"] = "UPGRADE";
    EthTxType["BUY_HAT"] = "BUY_HAT";
    EthTxType["PLANET_TRANSFER"] = "PLANET_TRANSFER";
    EthTxType["FIND_ARTIFACT"] = "FIND_ARTIFACT";
    EthTxType["PROSPECT_PLANET"] = "PROSPECT_PLANET";
    EthTxType["DEPOSIT_ARTIFACT"] = "DEPOSIT_ARTIFACT";
    EthTxType["WITHDRAW_ARTIFACT"] = "WITHDRAW_ARTIFACT";
    EthTxType["ACTIVATE_ARTIFACT"] = "ACTIVATE_ARTIFACT";
    EthTxType["DEACTIVATE_ARTIFACT"] = "DEACTIVATE_ARTIFACT";
    EthTxType["WITHDRAW_SILVER"] = "WITHDRAW_SILVER";
    // DarkForestGPTCredit
    EthTxType["BUY_GPT_CREDITS"] = "BUY_GPT_CREDITS";
})(EthTxType = exports.EthTxType || (exports.EthTxType = {}));
/**
 * @hidden
 */
exports.TxTypeToEthFunctionName = {
    [EthTxType.REVEAL_LOCATION]: 'revealLocation',
    [EthTxType.INIT]: 'initializePlayer',
    [EthTxType.MOVE]: 'move',
    [EthTxType.UPGRADE]: 'upgradePlanet',
    [EthTxType.BUY_HAT]: 'buyHat',
    [EthTxType.PLANET_TRANSFER]: 'transferOwnership',
    [EthTxType.FIND_ARTIFACT]: 'findArtifact',
    [EthTxType.DEPOSIT_ARTIFACT]: 'depositArtifact',
    [EthTxType.WITHDRAW_ARTIFACT]: 'withdrawArtifact',
    [EthTxType.PROSPECT_PLANET]: 'prospectPlanet',
    [EthTxType.ACTIVATE_ARTIFACT]: 'activateArtifact',
    [EthTxType.DEACTIVATE_ARTIFACT]: 'deactivateArtifact',
    [EthTxType.WITHDRAW_SILVER]: 'withdrawSilver',
    // DarkForestGPTCredit
    [EthTxType.BUY_GPT_CREDITS]: 'buyCredits',
};
/**
 * @hidden
 */
var EthTxStatus;
(function (EthTxStatus) {
    EthTxStatus[EthTxStatus["Init"] = 0] = "Init";
    EthTxStatus[EthTxStatus["Submit"] = 1] = "Submit";
    EthTxStatus[EthTxStatus["Confirm"] = 2] = "Confirm";
    EthTxStatus[EthTxStatus["Fail"] = 3] = "Fail";
})(EthTxStatus = exports.EthTxStatus || (exports.EthTxStatus = {}));
